import { jsx as p } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { MaskInput as i } from "../../MaskInput/MaskInput.mjs";
import "../../MaskInput/MaskBase.mjs";
const s = m((r, t) => {
  const { ...o } = r;
  return /* @__PURE__ */ p(i, { ref: t, format: "##/##", mask: ["M", "M", "Y", "Y"], ...o });
});
s.displayName = "CCExpiryInput";
export {
  s as CCExpiryInput
};
